import React from 'react';

export type ImgProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'loading' | 'decoding'> & {
  width?: number;
  height?: number;
  aspectRatio?: number;
  priority?: boolean;
  loading?: 'lazy' | 'eager';
  decoding?: 'async' | 'sync' | 'auto';
};

export const Img: React.FC<ImgProps> = ({
  width,
  height,
  aspectRatio,
  priority,
  loading,
  decoding = 'async',
  style,
  ...rest
}) => {
  // Derive missing dimension if aspectRatio is provided
  let resolvedWidth = width;
  let resolvedHeight = height;
  if (aspectRatio && (width || height)) {
    if (width && !height) {
      resolvedHeight = Math.round(width / aspectRatio);
    } else if (height && !width) {
      resolvedWidth = Math.round(height * aspectRatio);
    }
  }

  const finalLoading: 'lazy' | 'eager' | undefined = priority ? 'eager' : loading;

  // Apply CSS aspect-ratio if only aspectRatio provided without concrete dimensions
  const aspectStyle = aspectRatio && !resolvedWidth && !resolvedHeight ? { aspectRatio } : {};

  return (
    <img
      {...rest}
      width={resolvedWidth}
      height={resolvedHeight}
      loading={finalLoading}
      decoding={decoding}
      style={{ ...aspectStyle, ...style }}
    />
  );
};

export default Img;


